import { orgBrand } from '../graphql/signing_room_queries.gql'

export default {
  name: 'BrandMixin',
  data () {
    return {
      sn_themeMixin_hasColors: false
    }
  },
  created () {
    this.getBrand()
  },
  computed: {
    orgId () {
      return this.$store?.getters?.orgId
    }
  },
  watch: {
    orgId (newOrgId) {
      if (newOrgId) {
        this.getBrand()
      } else {
        this.sn_themeMixin_setVuetifyColorsFromResponseData({})
      }
    }
  },
  methods: {
    getBrand () {
      this.$apollo.query({
        query: orgBrand,
        variables: {
          orgGuid: this.orgId
        }
      }).then(({ data }) => {
        if (!data.orgBrand) {
          return
        }
        const { color } = data.orgBrand
        const colors = { primary: color }
        this.sn_themeMixin_setVuetifyColorsFromResponseData(colors)
      }).catch(console.error)
    },
    /**
     * as part of SNUI, we expose a brand color as well as a few lighter shades of a brand color for certain use cases.
     * This function can take a brand color and calculate the shades we need as a solid color instead of a transparent
     * color.
     * @param {string} hex - expects valid hex value matching '#ffffff' or 'ffffff'
     * @param {*} pct - epected as decimal 0..1
     */
    sn_themeMixin_createColorShade (hex, pct) {
      return hex
        // find and split out each rgb values into list of individual hex values e.g. '#ffffff' ->[ 'ff'. 'ff'. 'ff' ]
        .replace(/.{0,1}([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})/, '$1 $2 $3')
        .split(' ')
        .map(hexColor => parseInt(hexColor, 16)) // convert hex to int e.g. 'ff' -> 255
        .map(intColor => this.sn_themeMixin_convertToSolidOpacity(intColor, pct)) // convert color
        .map(intColor => (intColor).toString(16)) // convert back to hex e.g. e.g. 255 -> 'ff'
        .join('') // convert back to string and add hash back
        .padStart(7, '#')
    },
    /**
     * the algo here is a simplified version of the algo used by the css rgba 'a' value.
     * The simplification of the algo makes the conversion from one color to another entirely solid instead of
     * transparent which for brand colors is what we want
     * https://www.figma.com/file/XrbER66u1BdbkJfJ0z4DJX/SNUI-v1.1?node-id=1560%3A22704
     * @param {number} color - expected value 0..255
     * @param {number} opacity - expected value 0..1
     */
    sn_themeMixin_convertToSolidOpacity (color, opacity) {
      return Math.round(255 - opacity * (255 - color))
    },
    sn_themeMixin_validHexCode (hexCode) {
      return /^#[0-9A-F]{6}$/i.test(hexCode)
    },
    sn_themeMixin_setVuetifyColorsFromResponseData (colors) {
      const primaryColor = this.sn_themeResponseIsValid(colors, 'primary') ? colors.primary : '#11395B'
      const secondaryColor = this.sn_themeResponseIsValid(colors, 'secondary') ? colors.secondary : '#C3CDD6'
      const accentColor = this.sn_themeResponseIsValid(colors, 'secondary') ? colors.accent : primaryColor
      if (this.$vuetify?.theme?.themes !== undefined) { // vuetify 2 theme structure
        this.$vuetify.theme.themes.light.primary = primaryColor
        this.$vuetify.theme.themes.light.secondary = secondaryColor
        this.$vuetify.theme.themes.light.accent = accentColor
        // vuetify 2 apps also include the snui lib. So we can change brand colors
        // provide update brand colors to vuetify theme
        this.$vuetify.theme.themes.light.snBrand = primaryColor
        this.$vuetify.theme.themes.light.snBrand01 = this.sn_themeMixin_createColorShade(primaryColor, 0.05)
        this.$vuetify.theme.themes.light.snBrand02 = this.sn_themeMixin_createColorShade(primaryColor, 0.25)
        this.$vuetify.theme.themes.light.snBrand03 = primaryColor

        // some snui comopnents use css variables to grab brand colors
        const r = document.querySelector(':root')
        r.style.setProperty('--sn-brand-01', this.$vuetify.theme.themes.light.snBrand01)
        r.style.setProperty('--sn-brand-02', this.$vuetify.theme.themes.light.snBrand02)
        r.style.setProperty('--sn-brand-03', this.$vuetify.theme.themes.light.snBrand03)
      } else { // vuetify 1 theme structure
        this.$vuetify.theme.primary = primaryColor
        this.$vuetify.theme.secondary = secondaryColor
        this.$vuetify.theme.accent = accentColor
      }
      this.customColorsRetrieved = true
    },
    sn_themeResponseIsValid (colors, type) {
      return colors && colors[type] !== '' && this.sn_themeMixin_validHexCode(colors[type])
    }
  }
}
